(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bcw-kit-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bcw-kit-options')) {
    customElements.define('bcw-kit-options', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.readyHandler = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        this.removeEventListener('change', this.changeHandler);
        this.info?.removeEventListener('change', this.syncHandler);
        this.initialized = false;
      }

      initialize() {
        if (this.initialized) return;
        this.root = this.closest('[data-bcw-kit-variants]');
        this.info = this.closest('product-info');
        this.form = document.getElementById(this.dataset.formId);
        this.selects = Array.from(this.querySelectorAll('select[data-option-index]'));
        this.cards = new Map(Array.from(this.root?.querySelectorAll('[data-bcw-legacy-kit-variants] label[data-variant-id]') || []).map(card => [card.dataset.variantId, card]));
        try {
          this.variants = JSON.parse(this.querySelector('[data-kit-variant-data]').textContent).filter(variant => this.cards.has(String(variant.id)));
        } catch (_) { return; }
        if (!this.form || !this.info || !this.variants.length || !this.selects.length) return;
        const currentCard = Array.from(this.cards.values()).find(card => card.querySelector('input:checked'));
        this.current = this.variants.find(variant => String(variant.id) === currentCard?.dataset.variantId);
        if (!this.current) return;
        this.selects.forEach((select, index) => {
          Array.from(select.options).forEach(option => {
            if (!this.variants.some(variant => variant.options[index] === option.value)) option.remove();
          });
        });
        this.changeHandler = event => {
          if (!event.target.matches('select[data-option-index]')) return;
          const index = Number(event.target.dataset.optionIndex);
          const selected = this.selects.map(select => select.value);
          const exact = this.variants.find(variant => variant.options.every((value, i) => value === selected[i]));
          const candidates = this.variants.filter(variant => variant.options.every((value, i) => i > index || value === selected[i]));
          const next = exact || candidates.find(variant => this.cards.get(String(variant.id)).dataset.variantAvailable === 'true') || candidates[0];
          if (next) this.chooseVariant(next);
          else this.syncSelects();
        };
        this.syncHandler = event => {
          if (this.contains(event.target)) return;
          const checked = Array.from(this.cards.values()).find(card => card.querySelector('input:checked'));
          this.current = this.variants.find(variant => String(variant.id) === checked?.dataset.variantId) || this.current;
          this.syncSelects();
          this.showAvailability();
        };
        this.addEventListener('change', this.changeHandler);
        this.info.addEventListener('change', this.syncHandler);
        this.syncSelects();
        this.showAvailability();
        this.initialized = true;
        this.hidden = false;
        this.root.setAttribute('data-bcw-ready', '');
      }

      syncSelects() {
        this.selects.forEach((select, index) => { select.value = this.current.options[index]; });
      }

      showAvailability() {
        const card = this.cards.get(String(this.current.id));
        const available = card.dataset.variantAvailable === 'true';
        const status = this.querySelector('[data-kit-availability]');
        status.hidden = available;
        status.textContent = available ? '' : this.dataset.unavailableLabel;
        if (!available) {
          const input = this.form.querySelector('.product-variant-id');
          const button = this.form.querySelector('button[name="add"]');
          input.disabled = true;
          button.disabled = true;
          button.querySelector('span').textContent = this.dataset.unavailableLabel.toUpperCase();
        }
      }

      chooseVariant(variant) {
        this.current = variant;
        const card = this.cards.get(String(variant.id));
        if (card.dataset.variantAvailable === 'true') {
          card.click();
        } else {
          this.cards.forEach(candidate => {
            const selected = candidate === card;
            candidate.classList.toggle('selected', selected);
            candidate.querySelector('input[type="radio"]').checked = selected;
          });
          this.form.querySelector('.product-variant-id').value = String(variant.id);
          const price = this.info.querySelector('[data-selected-variant-current]');
          const status = this.info.querySelector('[data-selected-variant-status]');
          if (price) price.textContent = card.dataset.variantPrice;
          if (status) status.hidden = false;
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
        this.syncSelects();
        this.showAvailability();
        if (variant.media_id) {
          const gallery = document.getElementById('MediaGallery-' + this.dataset.sectionId);
          const slides = Array.from(gallery?.querySelectorAll('[data-media-id]') || []);
          const index = slides.findIndex(slide => slide.dataset.mediaId === this.dataset.sectionId + '-' + variant.media_id);
          const goToSlide = window['goToSlide' + this.dataset.sectionId.replace(/-/g, '')];
          if (index >= 0 && typeof goToSlide === 'function') goToSlide(index);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
